// import React, { useState, useRef, useEffect } from 'react';
// import {
//   MapPin, Search, Zap, RotateCcw, Star, Phone, Globe,
//   ExternalLink, Download, Bookmark, ChevronLeft, ChevronRight,
//   X, Filter, CheckSquare
// } from 'lucide-react';
// import { BUSINESS_CATEGORIES, RADIUS_OPTIONS, SORT_OPTIONS } from '../utils/constants';
// import api from '../utils/api';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// // ─────────────────────────────────────────────────────────────────────────────
// // Constants & helpers
// // ─────────────────────────────────────────────────────────────────────────────
// const DFLT = {
//   location: '', radius: 5000, businessTypes: [], keyword: '',
//   minRating: 0, statusFilter: '', hasPhone: false, hasWebsite: false,
//   openedWithin: '',
// };

// const OPENED_WITHIN_OPTIONS = [
//   { value: '',   label: 'Any time'    },
//   { value: '1',  label: 'Last 1 day'  },
//   { value: '5',  label: 'Last 5 days' },
//   { value: '10', label: 'Last 10 days'},
//   { value: '20', label: 'Last 20 days'},
//   { value: '30', label: 'Last 30 days'},
//   { value: '60', label: 'Last 2 months'},
//   { value: '90', label: 'Last 3 months'},
// ];

// function normalizeLead(l) {
//   return {
//     ...l,
//     rating:       l.rating       != null ? Number(l.rating)       : null,
//     lead_score:   l.lead_score   != null ? Number(l.lead_score)   : 0,
//     review_count: l.review_count != null ? Number(l.review_count) : 0,
//   };
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // Tiny style helpers (returns plain object)
// // ─────────────────────────────────────────────────────────────────────────────
// const S = {
//   // Layout
//   page:        { width: '100%', boxSizing: 'border-box', padding: '24px 28px', fontFamily: 'inherit' },
//   layout:      { display: 'flex', gap: 20, alignItems: 'flex-start', width: '100%', boxSizing: 'border-box' },
//   sidebar:     {
//     width: 280, minWidth: 280, flexShrink: 0,
//     background: 'var(--bg2)', border: '1px solid var(--border)',
//     borderRadius: 12, overflow: 'hidden',
//     position: 'sticky', top: 80, maxHeight: 'calc(100vh - 100px)', overflowY: 'auto',
//   },
//   main:        { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 14 },

//   // Cards
//   card:        { background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 },
//   cardSelected:{ background: 'var(--bg2)', border: '2px solid var(--accent)', borderRadius: 10, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 },

//   // Toolbar
//   toolbar:     {
//     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//     flexWrap: 'wrap', gap: 10,
//     background: 'var(--bg2)', border: '1px solid var(--border)',
//     borderRadius: 10, padding: '10px 14px',
//   },
//   toolbarLeft:  { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', flex: 1, minWidth: 0 },
//   toolbarRight: { display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 },

//   // Grid
//   grid:        { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 },

//   // Input
//   inputWrap:   { position: 'relative', width: '100%' },
//   input:       {
//     width: '100%', boxSizing: 'border-box', height: 36,
//     background: 'var(--bg3)', border: '1px solid var(--border)',
//     borderRadius: 7, fontSize: 13, color: 'var(--text)',
//     paddingLeft: 34, paddingRight: 12, outline: 'none',
//   },
//   inputPlain:  {
//     width: '100%', boxSizing: 'border-box', height: 36,
//     background: 'var(--bg3)', border: '1px solid var(--border)',
//     borderRadius: 7, fontSize: 13, color: 'var(--text)',
//     padding: '0 12px', outline: 'none',
//   },
//   inputIcon:   { position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)', pointerEvents: 'none' },
//   inputClear:  { position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text3)', padding: 2, display: 'flex' },

//   // Select
//   select:      {
//     width: '100%', boxSizing: 'border-box', height: 36,
//     background: 'var(--bg3)', border: '1px solid var(--border)',
//     borderRadius: 7, fontSize: 13, color: 'var(--text)',
//     padding: '0 10px', outline: 'none', cursor: 'pointer',
//   },

//   // Buttons
//   btnPrimary:  {
//     display: 'inline-flex', alignItems: 'center', gap: 6,
//     height: 36, padding: '0 16px', borderRadius: 8, border: 'none',
//     background: 'var(--accent)', color: '#fff', fontWeight: 600, fontSize: 13,
//     cursor: 'pointer', whiteSpace: 'nowrap',
//   },
//   btnPrimaryFull: {
//     display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
//     height: 38, width: '100%', borderRadius: 8, border: 'none',
//     background: 'var(--accent)', color: '#fff', fontWeight: 600, fontSize: 13,
//     cursor: 'pointer',
//   },
//   btnPrimaryDisabled: {
//     display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
//     height: 38, width: '100%', borderRadius: 8, border: 'none',
//     background: 'var(--border)', color: 'var(--text3)', fontWeight: 600, fontSize: 13,
//     cursor: 'not-allowed',
//   },
//   btnGhost:    {
//     display: 'inline-flex', alignItems: 'center', gap: 5,
//     height: 32, padding: '0 12px', borderRadius: 7,
//     border: '1px solid var(--border)', background: 'transparent',
//     color: 'var(--text2)', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap',
//   },
//   btnSuccess:  {
//     display: 'inline-flex', alignItems: 'center', gap: 5,
//     height: 32, padding: '0 12px', borderRadius: 7, border: 'none',
//     background: 'var(--green)', color: '#fff', fontSize: 12,
//     fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
//   },
//   btnReset:    {
//     display: 'inline-flex', alignItems: 'center', gap: 5,
//     height: 28, padding: '0 10px', borderRadius: 6,
//     border: '1px solid var(--border)', background: 'transparent',
//     color: 'var(--text3)', fontSize: 11, cursor: 'pointer',
//   },
//   btnIcon:     {
//     display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
//     width: 30, height: 30, borderRadius: 6,
//     border: '1px solid var(--border)', background: 'transparent',
//     color: 'var(--text3)', cursor: 'pointer',
//   },

//   // Chip
//   chip:        {
//     display: 'inline-flex', alignItems: 'center', height: 26,
//     padding: '0 10px', borderRadius: 20,
//     border: '1px solid var(--border)', background: 'var(--bg3)',
//     color: 'var(--text3)', fontSize: 11.5, cursor: 'pointer', whiteSpace: 'nowrap',
//   },
//   chipActive:  {
//     display: 'inline-flex', alignItems: 'center', height: 26,
//     padding: '0 10px', borderRadius: 20,
//     border: '1px solid var(--accent)', background: 'var(--accent)',
//     color: '#fff', fontSize: 11.5, cursor: 'pointer', whiteSpace: 'nowrap',
//   },

//   // Section label inside sidebar
//   sectionLabel: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, color: 'var(--text3)', marginBottom: 8 },
//   sectionDiv:   { padding: '14px 16px', borderBottom: '1px solid var(--border)' },

//   // Badge
//   badgeGreen: { display:'inline-flex', alignItems:'center', gap:4, padding:'2px 8px', borderRadius:20, background:'var(--green-bg,#dcfce7)', color:'var(--green,#16a34a)', fontSize:11, fontWeight:600 },
//   badgeRed:   { display:'inline-flex', alignItems:'center', gap:4, padding:'2px 8px', borderRadius:20, background:'#fee2e2', color:'#dc2626', fontSize:11, fontWeight:600 },
//   badgeGray:  { display:'inline-flex', alignItems:'center', gap:4, padding:'2px 8px', borderRadius:20, background:'var(--bg3)', color:'var(--text3)', fontSize:11, fontWeight:600 },

//   // Checkbox
//   checkbox:     { width:18, height:18, borderRadius:4, border:'2px solid var(--border)', background:'var(--bg3)', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },
//   checkboxOn:   { width:18, height:18, borderRadius:4, border:'2px solid var(--accent)', background:'var(--accent)', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },

//   // Score bar
//   scoreTrack:  { flex:1, height:5, borderRadius:3, background:'var(--border)', overflow:'hidden' },

//   // Empty / loading state
//   emptyState:  { display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'60px 20px', gap:12, textAlign:'center', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:12 },

//   // Autocomplete dropdown
//   dropdown:    { position:'absolute', top:'100%', left:0, right:0, zIndex:999, marginTop:4, background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:8, boxShadow:'0 8px 24px rgba(0,0,0,.12)', overflow:'hidden' },
//   dropItem:    { display:'flex', alignItems:'flex-start', gap:8, padding:'10px 12px', cursor:'pointer', borderBottom:'1px solid var(--border)', fontSize:13 },

//   // Modal
//   overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 },
//   modal:       { background:'var(--bg2)', borderRadius:14, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 24px 60px rgba(0,0,0,.25)' },
//   modalHeader: { display:'flex', alignItems:'flex-start', justifyContent:'space-between', padding:'20px 22px 16px', borderBottom:'1px solid var(--border)' },
//   modalBody:   { padding:'20px 22px' },
//   modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'14px 22px', borderTop:'1px solid var(--border)' },

//   // Misc
//   label:       { fontSize:12, color:'var(--text3)', marginBottom:4, display:'block' },
//   formGroup:   { display:'flex', flexDirection:'column', gap:4 },
//   textarea:    { width:'100%', boxSizing:'border-box', minHeight:80, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:7, fontSize:13, color:'var(--text)', padding:'8px 12px', outline:'none', resize:'vertical', fontFamily:'inherit' },
//   pagination:  { display:'flex', alignItems:'center', justifyContent:'center', gap:6 },
//   pageBtn:     { width:34, height:34, borderRadius:7, border:'1px solid var(--border)', background:'var(--bg3)', color:'var(--text2)', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
//   pageBtnActive: { width:34, height:34, borderRadius:7, border:'none', background:'var(--accent)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // LocationInput — location autocomplete via backend proxy
// // ─────────────────────────────────────────────────────────────────────────────
// function LocationInput({ value, onChange }) {
//   const [q, setQ]       = useState(value);
//   const [sug, setSug]   = useState([]);
//   const [open, setOpen] = useState(false);
//   const wrapRef = useRef(null);
//   const debRef  = useRef(null);

//   useEffect(() => { setQ(value); }, [value]);

//   useEffect(() => {
//     const h = e => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, []);

//   const suggest = async val => {
//     if (!val || val.length < 2) { setSug([]); return; }
//     try {
//       const r = await api.get('/leads/location-search', { params: { q: val } });
//       const results = r.data.results || [];
//       setSug(results);
//       setOpen(results.length > 0);
//     } catch { setSug([]); }
//   };

//   return (
//     <div ref={wrapRef} style={{ position:'relative', width:'100%' }}>
//       <div style={S.inputWrap}>
//         <span style={S.inputIcon}><MapPin size={14}/></span>
//         <input
//           style={S.input}
//           placeholder="Enter city, area, or landmark…"
//           value={q}
//           onChange={e => { const v=e.target.value; setQ(v); onChange(v); clearTimeout(debRef.current); debRef.current=setTimeout(()=>suggest(v),280); }}
//           onFocus={() => sug.length && setOpen(true)}
//         />
//         {q && <button style={S.inputClear} onClick={() => { setQ(''); onChange(''); setSug([]); }}><X size={12}/></button>}
//       </div>
//       {open && sug.length > 0 && (
//         <div style={S.dropdown}>
//           {sug.map((p,i) => (
//             <div key={p.place_id||i} style={S.dropItem}
//               onMouseDown={() => { setQ(p.main_text); onChange(p.main_text); setSug([]); setOpen(false); }}
//               onMouseEnter={e => e.currentTarget.style.background='var(--bg3)'}
//               onMouseLeave={e => e.currentTarget.style.background=''}
//             >
//               <MapPin size={13} style={{ color:'var(--accent)', flexShrink:0, marginTop:2 }}/>
//               <div>
//                 <div style={{ fontSize:13, color:'var(--text)', fontWeight:500 }}>{p.main_text}</div>
//                 {p.secondary && <div style={{ fontSize:11.5, color:'var(--text3)', marginTop:1 }}>{p.secondary}</div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // FilterSidebar — compact layout
// // ─────────────────────────────────────────────────────────────────────────────
// function FilterSidebar({ filters, onChange, onSearch, loading }) {
//   const [expanded, setExpanded] = useState([]);
//   const toggle = t => { const c=filters.businessTypes||[]; onChange({...filters, businessTypes: c.includes(t)?c.filter(x=>x!==t):[...c,t]}); };
//   const sel  = filters.businessTypes?.length || 0;
//   const busy = loading || !filters.location;

//   // Compact section style
//   const sec = { padding:'8px 12px', borderBottom:'1px solid var(--border)' };
//   const lbl = { fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:.9, color:'var(--text3)', marginBottom:5 };

//   return (
//     <div style={S.sidebar}>
//       {/* Header */}
//       <div style={{ padding:'10px 12px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
//         <span style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:1.2, color:'var(--text3)', display:'flex', alignItems:'center', gap:5 }}>
//           <Filter size={11}/>Filters {sel>0&&<span style={{ background:'var(--accent)', color:'#fff', borderRadius:8, padding:'0px 6px', fontSize:10, fontWeight:700, marginLeft:2 }}>{sel}</span>}
//         </span>
//         <button style={{ ...S.btnReset, height:24, fontSize:10 }} onClick={() => onChange(DFLT)}><RotateCcw size={10}/> Reset</button>
//       </div>

//       {/* Location */}
//       <div style={sec}>
//         <div style={lbl}>📍 Location</div>
//         <LocationInput value={filters.location} onChange={v => onChange({...filters, location:v})}/>
//       </div>

//       {/* Radius */}
//       <div style={sec}>
//         <div style={lbl}>Radius</div>
//         <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
//           {RADIUS_OPTIONS.map(o => (
//             <button key={o.value} style={{ ...(filters.radius===o.value ? S.chipActive : S.chip), height:22, fontSize:11, padding:'0 8px' }} onClick={() => onChange({...filters, radius:o.value})}>{o.label}</button>
//           ))}
//         </div>
//       </div>

//       {/* Keyword */}
//       <div style={sec}>
//         <div style={lbl}>🔍 Keyword</div>
//         <input style={{ ...S.inputPlain, height:32, fontSize:12 }} placeholder="e.g. digital marketing…" value={filters.keyword} onChange={e => onChange({...filters, keyword:e.target.value})}/>
//       </div>

//       {/* Business Types — all collapsed by default, compact */}
//       <div style={sec}>
//         <div style={{ ...lbl, display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
//           <span>Business Type</span>
//           {sel>0&&<span style={{ background:'var(--accent)', color:'#fff', borderRadius:8, padding:'0 6px', fontSize:10, fontWeight:700 }}>{sel} selected</span>}
//         </div>
//         {BUSINESS_CATEGORIES.map(cat => {
//           const catSel = (filters.businessTypes||[]).filter(t => cat.types.map(x=>x.value).includes(t)).length;
//           return (
//             <div key={cat.label} style={{ marginBottom:4 }}>
//               <div
//                 style={{ fontSize:11.5, fontWeight:600, color: catSel>0 ? 'var(--accent)' : 'var(--text2)', marginBottom:0, display:'flex', justifyContent:'space-between', alignItems:'center', cursor:'pointer', userSelect:'none', padding:'4px 6px', borderRadius:5, background: catSel>0?'var(--accent-bg)':'transparent' }}
//                 onClick={() => setExpanded(p => p.includes(cat.label) ? p.filter(x=>x!==cat.label) : [...p,cat.label])}
//               >
//                 <span style={{ display:'flex', alignItems:'center', gap:5 }}>{cat.icon} {cat.label} {catSel>0&&<span style={{ background:'var(--accent)', color:'#fff', borderRadius:8, padding:'0 5px', fontSize:9, fontWeight:700 }}>{catSel}</span>}</span>
//                 <span style={{ fontSize:9, color:'var(--text3)' }}>{expanded.includes(cat.label) ? '▲' : '▼'}</span>
//               </div>
//               {expanded.includes(cat.label) && (
//                 <div style={{ display:'flex', flexWrap:'wrap', gap:3, padding:'5px 4px 2px' }}>
//                   {cat.types.map(t => (
//                     <button key={t.value} style={{ ...(filters.businessTypes||[]).includes(t.value) ? S.chipActive : S.chip, height:20, fontSize:10.5, padding:'0 7px' }} onClick={() => toggle(t.value)}>{t.label}</button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Advanced — compact 2-col grid */}
//       <div style={sec}>
//         <div style={lbl}>Advanced</div>
//         <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
//           <div>
//             <div style={{ ...lbl, marginBottom:3 }}>Min Rating</div>
//             <select style={{ ...S.select, height:30, fontSize:12 }} value={filters.minRating} onChange={e => onChange({...filters, minRating:Number(e.target.value)})}>
//               {[[0,'Any'],[3,'3★+'],[3.5,'3.5★+'],[4,'4★+'],[4.5,'4.5★+']].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
//             </select>
//           </div>
//           <div>
//             <div style={{ ...lbl, marginBottom:3 }}>Status</div>
//             <select style={{ ...S.select, height:30, fontSize:12 }} value={filters.statusFilter} onChange={e => onChange({...filters, statusFilter:e.target.value})}>
//               <option value="">All</option>
//               <option value="OPERATIONAL">Open</option>
//               <option value="CLOSED_TEMPORARILY">Temp Closed</option>
//             </select>
//           </div>
//         </div>
//         <div style={{ marginTop:6 }}>
//           <div style={{ ...lbl, marginBottom:3 }}>🆕 Opened Recently</div>
//           <select style={{ ...S.select, height:30, fontSize:12 }} value={filters.openedWithin} onChange={e => onChange({...filters, openedWithin:e.target.value})}>
//             {OPENED_WITHIN_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
//           </select>
//         </div>
//         <div style={{ display:'flex', gap:14, marginTop:8 }}>
//           <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, cursor:'pointer', color:'var(--text2)' }}>
//             <input type="checkbox" style={{ accentColor:'var(--accent)' }} checked={filters.hasPhone||false} onChange={e => onChange({...filters, hasPhone:e.target.checked})}/> Phone
//           </label>
//           <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, cursor:'pointer', color:'var(--text2)' }}>
//             <input type="checkbox" style={{ accentColor:'var(--accent)' }} checked={filters.hasWebsite||false} onChange={e => onChange({...filters, hasWebsite:e.target.checked})}/> Website
//           </label>
//         </div>
//       </div>

//       {/* Search button */}
//       <div style={{ padding:'10px 12px' }}>
//         <button style={{ ...(busy ? S.btnPrimaryDisabled : S.btnPrimaryFull), height:36 }} onClick={onSearch} disabled={busy}>
//           {loading ? <><span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }}/> Searching…</> : <><Zap size={13}/> Generate Leads</>}
//         </button>
//         {!filters.location && <div style={{ fontSize:11, color:'var(--text3)', marginTop:5, textAlign:'center' }}>Enter a location to search</div>}
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // LeadCard
// // ─────────────────────────────────────────────────────────────────────────────
// function LeadCard({ lead, selected, onSelect, onSave, onDetail }) {
//   const [hovered, setHovered] = useState(false);
//   const status  = lead.business_status || lead.status || 'UNKNOWN';
//   const types   = (typeof lead.types==='string' ? JSON.parse(lead.types||'[]') : lead.types||[])
//     .filter(t => !['point_of_interest','establishment'].includes(t)).slice(0,3);
//   const rating  = lead.rating != null ? Number(lead.rating) : null;
//   const score   = Number(lead.lead_score) || 0;
//   const reviews = Number(lead.review_count || lead.reviewCount) || 0;

//   const badgeStyle = status==='OPERATIONAL' ? S.badgeGreen : status.includes('CLOSED') ? S.badgeRed : S.badgeGray;
//   const badgeLabel = status==='OPERATIONAL' ? 'Open' : status.includes('CLOSED') ? 'Closed' : 'Unknown';
//   const badgeDot   = { width:6, height:6, borderRadius:'50%', background: status==='OPERATIONAL'?'var(--green,#16a34a)':status.includes('CLOSED')?'#dc2626':'var(--text3)', flexShrink:0 };

//   const cardStyle = {
//     ...( selected ? S.cardSelected : S.card ),
//     transition: 'box-shadow .15s, transform .15s',
//     ...(hovered ? { boxShadow:'0 4px 16px rgba(0,0,0,.1)', transform:'translateY(-1px)' } : {}),
//   };

//   return (
//     <div style={cardStyle} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
//       {/* Header row */}
//       <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
//         <div style={selected ? S.checkboxOn : S.checkbox} onClick={() => onSelect(lead.id||lead.place_id)}>
//           {selected && <svg width="10" height="10" viewBox="0 0 10 10"><path d="M1.5 5l2.5 2.5 4.5-4.5" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>}
//         </div>
//         <div style={{ flex:1, minWidth:0 }}>
//           <div style={{ fontWeight:700, fontSize:14, color:'var(--text)', lineHeight:1.3, marginBottom:3, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{lead.name}</div>
//           <div style={{ display:'flex', alignItems:'center', gap:4, fontSize:12, color:'var(--text3)' }}>
//             <MapPin size={10} style={{ flexShrink:0 }}/><span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.address||lead.vicinity||'N/A'}</span>
//           </div>
//         </div>
//         <span style={badgeStyle}><span style={badgeDot}/>{badgeLabel}</span>
//       </div>

//       {/* Rating + score */}
//       {rating != null && rating > 0 && (
//         <div style={{ display:'flex', alignItems:'center', gap:10 }}>
//           <div style={{ display:'flex', alignItems:'center', gap:4, fontWeight:700, fontSize:13, color:'var(--gold,#f59e0b)' }}>
//             <Star size={12} fill="var(--gold,#f59e0b)" stroke="none"/>{rating.toFixed(1)}
//           </div>
//           <span style={{ fontSize:12, color:'var(--text3)' }}>{reviews.toLocaleString()} reviews</span>
//           {score > 0 && (
//             <div style={{ display:'flex', alignItems:'center', gap:6, flex:1 }}>
//               <div style={S.scoreTrack}><div style={{ height:'100%', borderRadius:3, width:`${score}%`, background: score>=70?'var(--green,#16a34a)':score>=40?'var(--gold,#f59e0b)':'#ef4444' }}/></div>
//               <span style={{ fontSize:10.5, fontWeight:700, flexShrink:0, color: score>=70?'var(--green,#16a34a)':score>=40?'var(--gold,#f59e0b)':'#ef4444' }}>{score}</span>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Contact */}
//       <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
//         {lead.phone && (
//           <div style={{ display:'flex', alignItems:'center', gap:7, fontSize:12.5 }}>
//             <Phone size={12} style={{ color:'var(--accent)', flexShrink:0 }}/>
//             <a href={`tel:${lead.phone}`} style={{ color:'var(--text2)', textDecoration:'none' }}>{lead.phone}</a>
//           </div>
//         )}
//         {lead.email && (
//           <div style={{ display:'flex', alignItems:'center', gap:7, fontSize:12.5 }}>
//             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0 }}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
//             <a href={`mailto:${lead.email}`} style={{ color:'var(--accent)', textDecoration:'none', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.email}</a>
//           </div>
//         )}
//         {lead.website && (
//           <div style={{ display:'flex', alignItems:'center', gap:7, fontSize:12.5 }}>
//             <Globe size={12} style={{ color:'var(--accent)', flexShrink:0 }}/>
//             <a href={lead.website} target="_blank" rel="noopener noreferrer" style={{ color:'var(--accent)', textDecoration:'none', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
//               {lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}
//             </a>
//           </div>
//         )}
//         {!lead.phone && !lead.email && !lead.website && <div style={{ fontSize:12, color:'var(--text3)' }}>No contact details</div>}
//       </div>

//       {/* Type chips */}
//       {types.length > 0 && (
//         <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
//           {types.map(t => (
//             <span key={t} style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:4, padding:'1px 7px', fontSize:10.5, color:'var(--text3)', textTransform:'capitalize' }}>
//               {t.replace(/_/g,' ')}
//             </span>
//           ))}
//         </div>
//       )}

//       {/* Footer actions */}
//       <div style={{ display:'flex', gap:6, paddingTop:4, borderTop:'1px solid var(--border)' }}>
//         <button style={{ ...S.btnGhost, flex:1, justifyContent:'center' }} onClick={() => onDetail(lead)}>Details</button>
//         <button style={{ ...S.btnGhost, flex:1, justifyContent:'center' }} onClick={() => onSave(lead)}><Bookmark size={11}/> Save</button>
//         <a href={`https://maps.google.com/?q=${encodeURIComponent((lead.name||'')+' '+(lead.address||''))}`} target="_blank" rel="noopener noreferrer"
//           style={{ ...S.btnGhost, flex:1, justifyContent:'center', textDecoration:'none' }}>
//           <ExternalLink size={11}/> Maps
//         </a>
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SearchPage (main)
// // ─────────────────────────────────────────────────────────────────────────────
// export default function SearchPage() {
//   const { user, updateUser } = useAuth();
//   const [filters, setFilters]   = useState(DFLT);
//   const [leads, setLeads]       = useState([]);
//   const [loading, setLoading]   = useState(false);
//   const [loadMsg, setLoadMsg]   = useState('');
//   const [selected, setSelected] = useState([]);
//   const [query, setQuery]       = useState('');
//   const [sortBy, setSortBy]     = useState('lead_score');
//   const [page, setPage]         = useState(1);
//   const [total, setTotal]       = useState(0);
//   const [totalPages, setPages]  = useState(1);
//   const [detailLead, setDetail] = useState(null);
//   const [saveModal, setSave]    = useState(null);
//   const [saveForm, setSaveForm] = useState({ listName:'Default', priority:'medium', notes:'' });
//   const PER = 100;

//   const search = async (pg = 1) => {
//     if (!filters.location) return;
//     setLoading(true); setLeads([]); setSelected([]); setPage(pg);
//     const msgs = ['📍 Finding location…','🔍 Searching businesses…','📋 Gathering contact details…','✅ Processing results…'];
//     let mi = 0;
//     const iv = setInterval(() => { setLoadMsg(msgs[Math.min(mi++, msgs.length-1)]); }, 2500);
//     try {
//       const r = await api.post('/leads/search', { ...filters, page:pg, limit:PER });
//       setLeads((r.data.leads||[]).map(normalizeLead));
//       setTotal(r.data.total||0);
//       setPages(r.data.pages||1);
//       if (user) updateUser({ search_credits:(user.search_credits||0)-1, total_searches:(user.total_searches||0)+1 });
//     } catch { setLeads([]); setTotal(0); }
//     finally { clearInterval(iv); setLoading(false); setLoadMsg(''); }
//   };

//   const filtered = leads.filter(l => {
//     if (!query) return true;
//     const q = query.toLowerCase();
//     return l.name?.toLowerCase().includes(q)||l.address?.toLowerCase().includes(q)||l.phone?.includes(q)||l.website?.toLowerCase().includes(q);
//   });

//   const sorted = [...filtered].sort((a,b) => {
//     if (sortBy==='rating_desc')  return (b.rating||0)-(a.rating||0);
//     if (sortBy==='reviews_desc') return (b.review_count||0)-(a.review_count||0);
//     if (sortBy==='name')         return (a.name||'').localeCompare(b.name||'');
//     return (b.lead_score||0)-(a.lead_score||0);
//   });

//   const toggleSel = id => setSelected(p => p.includes(id)?p.filter(x=>x!==id):[...p,id]);

//   const confirmSave = async () => {
//     if (!saveModal) return;
//     try {
//       await api.post('/leads/save', { leadId:saveModal.id, ...saveForm });
//       toast.success(`"${saveModal.name}" saved to ${saveForm.listName}`);
//       setSave(null);
//     } catch(e) { toast.error(e.response?.data?.message||'Failed to save'); }
//   };

//   const exportLeads = () => {
//     const rows = selected.length > 0 ? sorted.filter(l=>selected.includes(l.id||l.place_id)) : sorted;
//     const cols = ['name','address','phone','email','website','rating','review_count','business_status','lead_score'];
//     const csv  = [cols.join(','), ...rows.map(l=>cols.map(c=>`"${(l[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(new Blob([csv],{type:'text/csv'}));
//     a.download = 'leads.csv'; a.click();
//     toast.success(`Exported ${rows.length} leads`);
//   };

//   return (
//     <div style={S.page}>
//       <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>

//       {/* Page title */}
//       <div style={{ marginBottom:20 }}>
//         <h1 style={{ fontSize:22, fontWeight:800, margin:0, marginBottom:4, color:'var(--text)' }}>Search Leads</h1>
//         <p style={{ color:'var(--text3)', fontSize:14, margin:0 }}>Find businesses by location, type, and filters — search globally</p>
//       </div>

//       {/* Two-column layout */}
//       <div style={S.layout}>
//         <FilterSidebar filters={filters} onChange={setFilters} onSearch={() => search(1)} loading={loading}/>

//         <div style={S.main}>

//           {/* Toolbar */}
//           {leads.length > 0 && (
//             <div style={S.toolbar}>
//               <div style={S.toolbarLeft}>
//                 <span style={{ fontSize:13, color:'var(--text3)', whiteSpace:'nowrap' }}>
//                   <strong style={{ color:'var(--text)' }}>{total.toLocaleString()}</strong> leads found
//                 </span>
//                 <div style={{ ...S.inputWrap, maxWidth:220 }}>
//                   <span style={S.inputIcon}><Search size={13}/></span>
//                   <input style={S.input} placeholder="Filter results…" value={query} onChange={e=>setQuery(e.target.value)}/>
//                 </div>
//                 <select style={{ ...S.select, width:160 }} value={sortBy} onChange={e=>setSortBy(e.target.value)}>
//                   {SORT_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
//                 </select>
//               </div>
//               <div style={S.toolbarRight}>
//                 <button style={S.btnGhost} onClick={() => selected.length===sorted.length ? setSelected([]) : setSelected(sorted.map(l=>l.id||l.place_id))}>
//                   <CheckSquare size={13}/> {selected.length===sorted.length?'Deselect All':'Select All'}
//                 </button>
//                 <button style={S.btnSuccess} onClick={exportLeads}>
//                   <Download size={13}/> Export {selected.length>0?`(${selected.length})`:'CSV'}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Loading */}
//           {loading && (
//             <div style={S.emptyState}>
//               <div style={{ width:36, height:36, border:'3px solid var(--border)', borderTopColor:'var(--accent)', borderRadius:'50%', animation:'spin 0.7s linear infinite' }}/>
//               <div style={{ fontWeight:600, fontSize:15, color:'var(--text)' }}>{loadMsg||'Searching…'}</div>
//               <div style={{ fontSize:13, color:'var(--text3)' }}>Searching businesses globally</div>
//             </div>
//           )}

//           {/* Empty state */}
//           {!loading && leads.length===0 && (
//             <div style={S.emptyState}>
//               <div style={{ fontSize:40 }}>📡</div>
//               <div style={{ fontWeight:700, fontSize:17, color:'var(--text)' }}>Ready to find leads</div>
//               <div style={{ fontSize:13, color:'var(--text3)', maxWidth:340 }}>Enter a location, choose business categories, set your radius and click Generate Leads.</div>
//             </div>
//           )}

//           {/* Leads grid */}
//           {!loading && sorted.length > 0 && (
//             <div style={S.grid}>
//               {sorted.map(lead => (
//                 <LeadCard
//                   key={lead.id||lead.place_id}
//                   lead={lead}
//                   selected={selected.includes(lead.id||lead.place_id)}
//                   onSelect={toggleSel}
//                   onSave={l => setSave(l)}
//                   onDetail={setDetail}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Pagination */}
//           {!loading && totalPages > 1 && (
//             <div style={S.pagination}>
//               <button style={S.pageBtn} onClick={() => search(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
//               {Array.from({ length:Math.min(totalPages,7) },(_,i) => i+1).map(p => (
//                 <button key={p} style={page===p ? S.pageBtnActive : S.pageBtn} onClick={() => search(p)}>{p}</button>
//               ))}
//               <button style={S.pageBtn} onClick={() => search(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Detail modal */}
//       {detailLead && (
//         <div style={S.overlay} onClick={e=>e.target===e.currentTarget&&setDetail(null)}>
//           <div style={S.modal}>
//             <div style={S.modalHeader}>
//               <div>
//                 <div style={{ fontWeight:700, fontSize:17, color:'var(--text)' }}>{detailLead.name}</div>
//                 {Number(detailLead.rating)>0 && (
//                   <div style={{ display:'flex', alignItems:'center', gap:5, marginTop:5, fontSize:13, color:'var(--gold,#f59e0b)' }}>
//                     <Star size={13} fill="var(--gold,#f59e0b)" stroke="none"/>
//                     <strong>{Number(detailLead.rating).toFixed(1)}</strong>
//                     <span style={{ color:'var(--text3)' }}>({Number(detailLead.review_count||0).toLocaleString()} reviews)</span>
//                   </div>
//                 )}
//               </div>
//               <button style={S.btnIcon} onClick={()=>setDetail(null)}><X size={15}/></button>
//             </div>
//             <div style={S.modalBody}>
//               <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
//                 {[
//                   ['📍 Address',   detailLead.address||detailLead.vicinity],
//                   ['📞 Phone',     detailLead.phone],
//                   ['📧 Email',     detailLead.email],
//                   ['🌐 Website',   detailLead.website],
//                   ['⚡ Status',    detailLead.business_status||detailLead.status],
//                   ['🎯 Lead Score',detailLead.lead_score],
//                 ].filter(([,v])=>v).map(([l,v])=>(
//                   <div key={l} style={{ display:'flex', gap:12, alignItems:'flex-start' }}>
//                     <span style={{ flexShrink:0, width:110, color:'var(--text3)', fontSize:12.5 }}>{l}</span>
//                     <span style={{ fontSize:13, color:'var(--text)', wordBreak:'break-all' }}>{v}</span>
//                   </div>
//                 ))}
//                 <a href={`https://maps.google.com/?q=${encodeURIComponent((detailLead.name||'')+' '+(detailLead.address||''))}`} target="_blank" rel="noopener noreferrer"
//                   style={{ ...S.btnPrimary, marginTop:8, textDecoration:'none', justifyContent:'center' }}>
//                   <ExternalLink size={14}/> View on Map
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Save modal */}
//       {saveModal && (
//         <div style={S.overlay} onClick={e=>e.target===e.currentTarget&&setSave(null)}>
//           <div style={{ ...S.modal, maxWidth:400 }}>
//             <div style={S.modalHeader}>
//               <div style={{ fontWeight:700, fontSize:16, color:'var(--text)' }}>Save Lead</div>
//               <button style={S.btnIcon} onClick={()=>setSave(null)}><X size={15}/></button>
//             </div>
//             <div style={S.modalBody}>
//               <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
//                 <div style={{ fontWeight:600, fontSize:14, color:'var(--text)', padding:'8px 12px', background:'var(--bg3)', borderRadius:7 }}>{saveModal.name}</div>
//                 <div style={S.formGroup}>
//                   <label style={S.label}>List Name</label>
//                   <input style={S.inputPlain} value={saveForm.listName} onChange={e=>setSaveForm(f=>({...f,listName:e.target.value}))} placeholder="Default"/>
//                 </div>
//                 <div style={S.formGroup}>
//                   <label style={S.label}>Priority</label>
//                   <select style={S.select} value={saveForm.priority} onChange={e=>setSaveForm(f=>({...f,priority:e.target.value}))}>
//                     {['low','medium','high','urgent'].map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
//                   </select>
//                 </div>
//                 <div style={S.formGroup}>
//                   <label style={S.label}>Notes</label>
//                   <textarea style={S.textarea} value={saveForm.notes} onChange={e=>setSaveForm(f=>({...f,notes:e.target.value}))} placeholder="Add notes about this lead…"/>
//                 </div>
//               </div>
//             </div>
//             <div style={S.modalFooter}>
//               <button style={S.btnGhost} onClick={()=>setSave(null)}>Cancel</button>
//               <button style={S.btnPrimary} onClick={confirmSave}><Bookmark size={13}/> Save Lead</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from 'react';
import {
  MapPin, Search, Zap, RotateCcw, Star, Phone, Globe,
  ExternalLink, Download, Bookmark, ChevronLeft, ChevronRight,
  X, Filter, CheckSquare, ChevronDown, SlidersHorizontal
} from 'lucide-react';
import { BUSINESS_CATEGORIES, RADIUS_OPTIONS, SORT_OPTIONS } from '../utils/constants';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const DFLT = {
  location:'', radius:5000, businessTypes:[], keyword:'',
  minRating:0, statusFilter:'', hasPhone:false, hasWebsite:false, openedWithin:'',
};

const OPENED_WITHIN = [
  {value:'',label:'Any time'},{value:'1',label:'Last 1 day'},{value:'5',label:'Last 5 days'},
  {value:'10',label:'Last 10 days'},{value:'20',label:'Last 20 days'},{value:'30',label:'Last 30 days'},
  {value:'60',label:'Last 2 months'},{value:'90',label:'Last 3 months'},
];

function normalizeLead(l) {
  return { ...l, rating:l.rating!=null?Number(l.rating):null, lead_score:Number(l.lead_score)||0, review_count:Number(l.review_count||l.reviewCount)||0 };
}

const S = {
  input:     { width:'100%', boxSizing:'border-box', height:40, background:'var(--surface)', border:'1px solid var(--border)', borderRadius:9, fontSize:13.5, color:'var(--text)', paddingLeft:38, paddingRight:32, outline:'none' },
  inputPlain:{ width:'100%', boxSizing:'border-box', height:36, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:7, fontSize:13, color:'var(--text)', padding:'0 12px', outline:'none' },
  select:    { width:'100%', boxSizing:'border-box', height:36, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:7, fontSize:13, color:'var(--text)', padding:'0 10px', outline:'none', cursor:'pointer' },
  chip:      { display:'inline-flex', alignItems:'center', height:30, padding:'0 12px', borderRadius:20, border:'1px solid var(--border)', background:'var(--bg3)', color:'var(--text2)', fontSize:12.5, cursor:'pointer', whiteSpace:'nowrap', fontWeight:500 },
  chipActive:{ display:'inline-flex', alignItems:'center', height:30, padding:'0 12px', borderRadius:20, border:'1px solid var(--accent)', background:'var(--accent)', color:'#fff', fontSize:12.5, cursor:'pointer', whiteSpace:'nowrap', fontWeight:600 },
  btnGhost:  { display:'inline-flex', alignItems:'center', gap:5, height:32, padding:'0 12px', borderRadius:7, border:'1px solid var(--border)', background:'transparent', color:'var(--text2)', fontSize:12, cursor:'pointer', whiteSpace:'nowrap' },
  btnSuccess:{ display:'inline-flex', alignItems:'center', gap:5, height:32, padding:'0 12px', borderRadius:7, border:'none', background:'var(--green)', color:'#fff', fontSize:12, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' },
  btnIcon:   { display:'inline-flex', alignItems:'center', justifyContent:'center', width:32, height:32, borderRadius:7, border:'1px solid var(--border)', background:'transparent', color:'var(--text3)', cursor:'pointer', flexShrink:0 },
  checkbox:  { width:18, height:18, borderRadius:4, border:'2px solid var(--border)', background:'var(--bg3)', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },
  checkboxOn:{ width:18, height:18, borderRadius:4, border:'2px solid var(--accent)', background:'var(--accent)', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },
  badgeGreen:{ display:'inline-flex', alignItems:'center', gap:4, padding:'2px 7px', borderRadius:20, background:'var(--green-bg)', color:'var(--green)', fontSize:11, fontWeight:600, flexShrink:0 },
  badgeRed:  { display:'inline-flex', alignItems:'center', gap:4, padding:'2px 7px', borderRadius:20, background:'#fee2e2', color:'#dc2626', fontSize:11, fontWeight:600, flexShrink:0 },
  badgeGray: { display:'inline-flex', alignItems:'center', gap:4, padding:'2px 7px', borderRadius:20, background:'var(--bg3)', color:'var(--text3)', fontSize:11, fontWeight:600, flexShrink:0 },
  scoreTrack:{ flex:1, height:5, borderRadius:3, background:'var(--border)', overflow:'hidden' },
  emptyState:{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'64px 20px', gap:14, textAlign:'center', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:14 },
  dropdown:  { position:'absolute', top:'100%', left:0, zIndex:999, marginTop:6, background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, boxShadow:'0 12px 32px rgba(0,0,0,.14)', overflow:'hidden', minWidth:220 },
  overlay:   { position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 },
  modal:     { background:'var(--surface)', borderRadius:14, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 24px 60px rgba(0,0,0,.25)' },
  textarea:  { width:'100%', boxSizing:'border-box', minHeight:80, background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:7, fontSize:13, color:'var(--text)', padding:'8px 12px', outline:'none', resize:'vertical', fontFamily:'inherit' },
  pageBtn:   { width:34, height:34, borderRadius:7, border:'1px solid var(--border)', background:'var(--bg3)', color:'var(--text2)', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
  pageBtnAct:{ width:34, height:34, borderRadius:7, border:'none', background:'var(--accent)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
};

// ── LocationInput ──────────────────────────────────────────────────────────
function LocationInput({ value, onChange }) {
  const [q, setQ]      = useState(value);
  const [sug, setSug]  = useState([]);
  const [open, setOpen]= useState(false);
  const wrapRef = useRef(null);
  const debRef  = useRef(null);
  useEffect(() => { setQ(value); }, [value]);
  useEffect(() => {
    const h = e => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const suggest = async val => {
    if (!val || val.length < 2) { setSug([]); return; }
    try { const r = await api.get('/leads/location-search',{params:{q:val}}); const res=r.data.results||[]; setSug(res); setOpen(res.length>0); }
    catch { setSug([]); }
  };
  return (
    <div ref={wrapRef} style={{ position:'relative', flex:'1 1 280px', minWidth:200 }}>
      <span style={{ position:'absolute', left:11, top:'50%', transform:'translateY(-50%)', color:'var(--text3)', pointerEvents:'none' }}><MapPin size={15}/></span>
      <input style={S.input} placeholder="City, area, or landmark…" value={q}
        onChange={e=>{const v=e.target.value;setQ(v);onChange(v);clearTimeout(debRef.current);debRef.current=setTimeout(()=>suggest(v),280);}}
        onFocus={()=>sug.length&&setOpen(true)}
        onKeyDown={e=>e.key==='Enter'&&onChange(q)}/>
      {q&&<button style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text3)', padding:2, display:'flex' }} onClick={()=>{setQ('');onChange('');setSug([]);}}><X size={13}/></button>}
      {open&&sug.length>0&&(
        <div style={{ ...S.dropdown, minWidth:'100%' }}>
          {sug.map((p,i)=>(
            <div key={p.place_id||i} style={{display:'flex',alignItems:'flex-start',gap:8,padding:'10px 14px',cursor:'pointer',borderBottom:'1px solid var(--border)',fontSize:13}}
              onMouseDown={()=>{setQ(p.main_text);onChange(p.main_text);setSug([]);setOpen(false);}}
              onMouseEnter={e=>e.currentTarget.style.background='var(--bg3)'}
              onMouseLeave={e=>e.currentTarget.style.background=''}>
              <MapPin size={13} style={{color:'var(--accent)',flexShrink:0,marginTop:2}}/>
              <div><div style={{color:'var(--text)',fontWeight:500}}>{p.main_text}</div>{p.secondary&&<div style={{fontSize:11.5,color:'var(--text3)',marginTop:1}}>{p.secondary}</div>}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Dropdown pill (for radius, category, advanced) ─────────────────────────
function DropdownPill({ label, active, badge, children, align='left' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  return (
    <div ref={ref} style={{ position:'relative', flexShrink:0 }}>
      <button onClick={()=>setOpen(p=>!p)}
        style={{ display:'inline-flex', alignItems:'center', gap:6, height:40, padding:'0 14px', borderRadius:9,
          border:`1.5px solid ${active?'var(--accent)':'var(--border)'}`,
          background:active?'var(--accent-bg)':'var(--surface)',
          color:active?'var(--accent)':'var(--text2)', fontSize:13, cursor:'pointer', fontWeight:active?700:500, whiteSpace:'nowrap' }}>
        {label}
        {badge!=null&&badge>0&&<span style={{background:'var(--accent)',color:'#fff',borderRadius:8,padding:'0 5px',fontSize:10,fontWeight:700,lineHeight:'16px'}}>{badge}</span>}
        <ChevronDown size={13} style={{opacity:.6,transform:open?'rotate(180deg)':'none',transition:'transform .15s'}}/>
      </button>
      {open&&(
        <div style={{...S.dropdown, left:align==='right'?'auto':0, right:align==='right'?0:'auto', maxHeight:360, overflowY:'auto'}}>
          <div onClick={e=>e.stopPropagation()}>
            {children}
          </div>
          <div style={{padding:'8px 12px',borderTop:'1px solid var(--border)'}}>
            <button onClick={()=>setOpen(false)} style={{width:'100%',height:32,borderRadius:7,border:'none',background:'var(--accent)',color:'#fff',fontSize:12.5,fontWeight:600,cursor:'pointer'}}>Apply</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── TopFilterBar ──────────────────────────────────────────────────────────
function TopFilterBar({ filters, onChange, onSearch, loading }) {
  const sel = filters.businessTypes?.length || 0;
  const busy = loading || !filters.location;

  // Count active advanced filters
  const advCount = (filters.minRating>0?1:0)+(filters.statusFilter?1:0)+(filters.hasPhone?1:0)+(filters.hasWebsite?1:0)+(filters.openedWithin?1:0)+(filters.keyword?1:0);

  const toggle = t => { const c=filters.businessTypes||[]; onChange({...filters,businessTypes:c.includes(t)?c.filter(x=>x!==t):[...c,t]}); };

  return (
    <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:14, padding:'14px 16px', marginBottom:16, display:'flex', flexDirection:'column', gap:10 }}>
      {/* Row 1: Location + Search button */}
      <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
        <LocationInput value={filters.location} onChange={v=>onChange({...filters,location:v})}/>
        <button onClick={onSearch} disabled={busy}
          style={{ display:'flex', alignItems:'center', gap:7, height:40, padding:'0 20px', borderRadius:9, border:'none', fontWeight:700, fontSize:14, cursor:busy?'not-allowed':'pointer', background:busy?'var(--border)':'var(--accent)', color:busy?'var(--text3)':'#fff', flexShrink:0, whiteSpace:'nowrap' }}>
          {loading
            ? <><span style={{width:14,height:14,border:'2px solid #fff',borderTopColor:'transparent',borderRadius:'50%',display:'inline-block',animation:'spin .7s linear infinite'}}/> Searching…</>
            : <><Zap size={14}/> Search Leads</>}
        </button>
        <button onClick={()=>onChange(DFLT)} style={{ ...S.btnGhost, height:40, gap:5, flexShrink:0 }} title="Reset all filters">
          <RotateCcw size={13}/> <span className="hide-mobile">Reset</span>
        </button>
      </div>

      {/* Row 2: Filter pills */}
      <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
        {/* Radius */}
        <DropdownPill label={`Radius: ${RADIUS_OPTIONS.find(r=>r.value===filters.radius)?.label||'5km'}`} active={filters.radius!==5000}>
          <div style={{padding:'12px 14px'}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:.9,color:'var(--text3)',marginBottom:8}}>Search Radius</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
              {RADIUS_OPTIONS.map(o=>(
                <button key={o.value} style={{...(filters.radius===o.value?S.chipActive:S.chip),height:28}}
                  onClick={()=>onChange({...filters,radius:o.value})}>{o.label}</button>
              ))}
            </div>
          </div>
        </DropdownPill>

        {/* Business Category */}
        <DropdownPill label="Category" active={sel>0} badge={sel}>
          <div style={{padding:'12px 14px',minWidth:260}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:.9,color:'var(--text3)',marginBottom:10}}>
              Business Type {sel>0&&<span style={{color:'var(--accent)'}}>{sel} selected</span>}
            </div>
            {BUSINESS_CATEGORIES.map(cat=>{
              const catSel=(filters.businessTypes||[]).filter(t=>cat.types.map(x=>x.value).includes(t)).length;
              return(
                <div key={cat.label} style={{marginBottom:10}}>
                  <div style={{fontSize:12,fontWeight:700,color:catSel>0?'var(--accent)':'var(--text2)',marginBottom:5,display:'flex',alignItems:'center',gap:6}}>
                    {cat.icon} {cat.label}
                    {catSel>0&&<span style={{background:'var(--accent)',color:'#fff',borderRadius:8,padding:'0 5px',fontSize:9,fontWeight:700}}>{catSel}</span>}
                  </div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                    {cat.types.map(t=>(
                      <button key={t.value} style={{...(filters.businessTypes||[]).includes(t.value)?S.chipActive:S.chip,height:24,fontSize:11,padding:'0 8px'}}
                        onClick={()=>toggle(t.value)}>{t.label}</button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </DropdownPill>

        {/* Rating */}
        <DropdownPill label={filters.minRating>0?`${filters.minRating}★+`:'Rating'} active={filters.minRating>0}>
          <div style={{padding:'12px 14px'}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:.9,color:'var(--text3)',marginBottom:8}}>Min Rating</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
              {[[0,'Any'],[3,'3★+'],[3.5,'3.5★+'],[4,'4★+'],[4.5,'4.5★+']].map(([v,l])=>(
                <button key={v} style={{...(filters.minRating===v?S.chipActive:S.chip),height:28}}
                  onClick={()=>onChange({...filters,minRating:v})}>{l}</button>
              ))}
            </div>
          </div>
        </DropdownPill>

        {/* Keyword */}
        <DropdownPill label={filters.keyword?`"${filters.keyword}"`:' Keyword'} active={!!filters.keyword}>
          <div style={{padding:'12px 14px',minWidth:220}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:.9,color:'var(--text3)',marginBottom:8}}>Keyword Search</div>
            <input style={S.inputPlain} placeholder="e.g. digital marketing…" value={filters.keyword} onChange={e=>onChange({...filters,keyword:e.target.value})}/>
          </div>
        </DropdownPill>

        {/* Advanced */}
        <DropdownPill label="More Filters" active={advCount>0} badge={advCount} align="right">
          <div style={{padding:'14px 16px',minWidth:250}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:.9,color:'var(--text3)',marginBottom:12}}>Advanced Filters</div>
            <div style={{display:'flex',flexDirection:'column',gap:12}}>
              <div>
                <div style={{fontSize:11.5,fontWeight:600,color:'var(--text2)',marginBottom:5}}>Business Status</div>
                <div style={{display:'flex',gap:6}}>
                  {[['','All'],['OPERATIONAL','Open'],['CLOSED_TEMPORARILY','Temp Closed']].map(([v,l])=>(
                    <button key={v} style={{...(filters.statusFilter===v?S.chipActive:S.chip),height:26,fontSize:11.5}}
                      onClick={()=>onChange({...filters,statusFilter:v})}>{l}</button>
                  ))}
                </div>
              </div>
              <div>
                <div style={{fontSize:11.5,fontWeight:600,color:'var(--text2)',marginBottom:5}}>🆕 Opened Recently</div>
                <select style={{...S.select,height:34,fontSize:12}} value={filters.openedWithin} onChange={e=>onChange({...filters,openedWithin:e.target.value})}>
                  {OPENED_WITHIN.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontSize:11.5,fontWeight:600,color:'var(--text2)',marginBottom:7}}>Contact Info</div>
                <div style={{display:'flex',gap:14}}>
                  <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5,cursor:'pointer',color:'var(--text2)'}}>
                    <input type="checkbox" style={{accentColor:'var(--accent)'}} checked={filters.hasPhone||false} onChange={e=>onChange({...filters,hasPhone:e.target.checked})}/> 📞 Has Phone
                  </label>
                  <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5,cursor:'pointer',color:'var(--text2)'}}>
                    <input type="checkbox" style={{accentColor:'var(--accent)'}} checked={filters.hasWebsite||false} onChange={e=>onChange({...filters,hasWebsite:e.target.checked})}/> 🌐 Has Website
                  </label>
                </div>
              </div>
            </div>
          </div>
        </DropdownPill>

        {/* Active filter summary chips */}
        {filters.hasPhone&&<span style={{...S.chipActive,height:26,fontSize:11.5,gap:4}}>📞 Phone <button style={{background:'none',border:'none',color:'#fff',cursor:'pointer',padding:0,display:'flex'}} onClick={()=>onChange({...filters,hasPhone:false})}><X size={10}/></button></span>}
        {filters.hasWebsite&&<span style={{...S.chipActive,height:26,fontSize:11.5,gap:4}}>🌐 Website <button style={{background:'none',border:'none',color:'#fff',cursor:'pointer',padding:0,display:'flex'}} onClick={()=>onChange({...filters,hasWebsite:false})}><X size={10}/></button></span>}
        {filters.statusFilter&&<span style={{...S.chipActive,height:26,fontSize:11.5,gap:4}}>{filters.statusFilter==='OPERATIONAL'?'Open Only':'Temp Closed'}<button style={{background:'none',border:'none',color:'#fff',cursor:'pointer',padding:0,display:'flex'}} onClick={()=>onChange({...filters,statusFilter:''})}><X size={10}/></button></span>}
      </div>
    </div>
  );
}

// ── LeadCard ───────────────────────────────────────────────────────────────
function LeadCard({ lead, selected, onSelect, onSave, onDetail }) {
  const status  = lead.business_status||lead.status||'UNKNOWN';
  const types   = (typeof lead.types==='string'?JSON.parse(lead.types||'[]'):lead.types||[]).filter(t=>!['point_of_interest','establishment'].includes(t)).slice(0,3);
  const rating  = lead.rating!=null?Number(lead.rating):null;
  const score   = Number(lead.lead_score)||0;
  const reviews = Number(lead.review_count||lead.reviewCount)||0;
  const badge   = status==='OPERATIONAL'?S.badgeGreen:status.includes('CLOSED')?S.badgeRed:S.badgeGray;
  const bTxt    = status==='OPERATIONAL'?'Open':status.includes('CLOSED')?'Closed':'Unknown';
  const dot     = {width:6,height:6,borderRadius:'50%',background:status==='OPERATIONAL'?'var(--green)':status.includes('CLOSED')?'#dc2626':'var(--text3)',flexShrink:0};

  return (
    <div style={{ background:'var(--surface)', border:`${selected?'2':'1'}px solid ${selected?'var(--accent)':'var(--border)'}`, borderRadius:11, padding:'13px 15px', display:'flex', flexDirection:'column', gap:9, transition:'box-shadow .15s' }}
      onMouseEnter={e=>e.currentTarget.style.boxShadow='0 3px 14px rgba(0,0,0,.08)'}
      onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
      {/* Header */}
      <div style={{display:'flex',alignItems:'flex-start',gap:9}}>
        <div style={selected?S.checkboxOn:S.checkbox} onClick={()=>onSelect(lead.id||lead.place_id)}>
          {selected&&<svg width="10" height="10" viewBox="0 0 10 10"><path d="M1.5 5l2.5 2.5 4.5-4.5" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>}
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:700,fontSize:13.5,lineHeight:1.3,marginBottom:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{lead.name}</div>
          <div style={{display:'flex',alignItems:'center',gap:4,fontSize:11.5,color:'var(--text3)'}}><MapPin size={10} style={{flexShrink:0}}/><span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{lead.address||lead.vicinity||'N/A'}</span></div>
        </div>
        <span style={badge}><span style={dot}/>{bTxt}</span>
      </div>
      {/* Rating */}
      {rating!=null&&rating>0&&(
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <div style={{display:'flex',alignItems:'center',gap:4,fontWeight:700,fontSize:12.5,color:'var(--gold)'}}><Star size={11} fill="var(--gold)" stroke="none"/>{rating.toFixed(1)}</div>
          <span style={{fontSize:11.5,color:'var(--text3)'}}>{reviews.toLocaleString()} reviews</span>
          {score>0&&<div style={{display:'flex',alignItems:'center',gap:5,flex:1}}><div style={S.scoreTrack}><div style={{height:'100%',borderRadius:3,width:`${score}%`,background:score>=70?'var(--green)':score>=40?'var(--gold)':'#ef4444'}}/></div><span style={{fontSize:10.5,fontWeight:700,flexShrink:0,color:score>=70?'var(--green)':score>=40?'var(--gold)':'#ef4444'}}>{score}</span></div>}
        </div>
      )}
      {/* Contact */}
      <div style={{display:'flex',flexDirection:'column',gap:4}}>
        {lead.phone&&<div style={{display:'flex',alignItems:'center',gap:7,fontSize:12.5}}><Phone size={11} style={{color:'var(--accent)',flexShrink:0}}/><a href={`tel:${lead.phone}`} style={{color:'var(--text2)',textDecoration:'none'}}>{lead.phone}</a></div>}
        {lead.email&&<div style={{display:'flex',alignItems:'center',gap:7,fontSize:12.5}}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
          <a href={`mailto:${lead.email}`} style={{color:'var(--accent)',textDecoration:'none',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{lead.email}</a>
        </div>}
        {lead.website&&<div style={{display:'flex',alignItems:'center',gap:7,fontSize:12.5}}><Globe size={11} style={{color:'var(--accent)',flexShrink:0}}/><a href={lead.website} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',textDecoration:'none',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{lead.website.replace(/^https?:\/\/(www\.)?/,'').split('/')[0]}</a></div>}
        {!lead.phone&&!lead.email&&!lead.website&&<div style={{fontSize:12,color:'var(--text3)'}}>No contact details</div>}
      </div>
      {/* Types */}
      {types.length>0&&<div style={{display:'flex',flexWrap:'wrap',gap:3}}>{types.map(t=><span key={t} style={{background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:4,padding:'1px 7px',fontSize:10.5,color:'var(--text3)',textTransform:'capitalize'}}>{t.replace(/_/g,' ')}</span>)}</div>}
      {/* Actions */}
      <div style={{display:'flex',gap:5,paddingTop:4,borderTop:'1px solid var(--border)'}}>
        <button style={{...S.btnGhost,flex:1,justifyContent:'center',height:29,fontSize:12}} onClick={()=>onDetail(lead)}>Details</button>
        <button style={{...S.btnGhost,flex:1,justifyContent:'center',height:29,fontSize:12}} onClick={()=>onSave(lead)}><Bookmark size={11}/> Save</button>
        <a href={`https://maps.google.com/?q=${encodeURIComponent((lead.name||'')+' '+(lead.address||''))}`} target="_blank" rel="noopener noreferrer"
          style={{...S.btnGhost,flex:1,justifyContent:'center',textDecoration:'none',height:29,fontSize:12}}><ExternalLink size={11}/> Maps</a>
      </div>
    </div>
  );
}

// ── SearchPage ─────────────────────────────────────────────────────────────
export default function SearchPage() {
  const { user, updateUser } = useAuth();
  const [filters, setFilters]   = useState(DFLT);
  const [leads, setLeads]       = useState([]);
  const [loading, setLoading]   = useState(false);
  const [loadMsg, setLoadMsg]   = useState('');
  const [selected, setSelected] = useState([]);
  const [query, setQuery]       = useState('');
  const [sortBy, setSortBy]     = useState('lead_score');
  const [page, setPage]         = useState(1);
  const [total, setTotal]       = useState(0);
  const [totalPages, setPages]  = useState(1);
  const [detailLead, setDetail] = useState(null);
  const [saveModal, setSave]    = useState(null);
  const [saveForm, setSaveForm] = useState({ listName:'Default', priority:'medium', notes:'' });
  const PER = 100;

  const search = async (pg = 1) => {
    if (!filters.location) return;
    setLoading(true); setLeads([]); setSelected([]); setPage(pg);
    const msgs = ['📍 Finding location…','🔍 Searching businesses…','📋 Gathering contact details…','✅ Processing results…'];
    let mi = 0;
    const iv = setInterval(() => { setLoadMsg(msgs[Math.min(mi++,msgs.length-1)]); }, 2500);
    try {
      const r = await api.post('/leads/search',{...filters,page:pg,limit:PER});
      setLeads((r.data.leads||[]).map(normalizeLead));
      setTotal(r.data.total||0); setPages(r.data.pages||1);
      if (user) updateUser({search_credits:(user.search_credits||0)-1,total_searches:(user.total_searches||0)+1});
    } catch { setLeads([]); setTotal(0); }
    finally { clearInterval(iv); setLoading(false); setLoadMsg(''); }
  };

  const filtered = leads.filter(l => {
    if (!query) return true;
    const q = query.toLowerCase();
    return l.name?.toLowerCase().includes(q)||l.address?.toLowerCase().includes(q)||l.phone?.includes(q)||l.website?.toLowerCase().includes(q);
  });
  const sorted = [...filtered].sort((a,b) => {
    if (sortBy==='rating_desc')  return (b.rating||0)-(a.rating||0);
    if (sortBy==='reviews_desc') return (b.review_count||0)-(a.review_count||0);
    if (sortBy==='name')         return (a.name||'').localeCompare(b.name||'');
    return (b.lead_score||0)-(a.lead_score||0);
  });
  const toggleSel = id => setSelected(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);

  const confirmSave = async () => {
    if (!saveModal) return;
    try { await api.post('/leads/save',{leadId:saveModal.id,...saveForm}); toast.success(`"${saveModal.name}" saved`); setSave(null); }
    catch(e) { toast.error(e.response?.data?.message||'Failed'); }
  };

  const exportLeads = () => {
    const rows = selected.length>0 ? sorted.filter(l=>selected.includes(l.id||l.place_id)) : sorted;
    const cols = ['name','address','phone','email','website','rating','review_count','business_status','lead_score'];
    const csv  = [cols.join(','),...rows.map(l=>cols.map(c=>`"${(l[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
    const a = document.createElement('a'); a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'})); a.download='leads.csv'; a.click();
    toast.success(`Exported ${rows.length} leads`);
  };

  return (
    <div style={{width:'100%',boxSizing:'border-box',padding:'20px 16px',maxWidth:1400,margin:'0 auto'}}>
      <style>{`
        @keyframes spin { to { transform:rotate(360deg) } }
        .leads-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:12px; }
        .hide-mobile { display:inline; }
        @media(max-width:600px){
          .leads-grid { grid-template-columns:1fr; }
          .hide-mobile { display:none; }
        }
        @media(min-width:480px) and (max-width:600px){ .leads-grid { grid-template-columns:repeat(2,1fr); } }
      `}</style>

      {/* Page title */}
      <div style={{marginBottom:14}}>
        <h1 style={{fontSize:'clamp(18px,4vw,22px)',fontWeight:800,margin:'0 0 3px',color:'var(--text)'}}>Search Leads</h1>
        <p style={{color:'var(--text3)',fontSize:13.5,margin:0}}>Find businesses globally — filter by location, category, rating and more</p>
      </div>

      {/* ── Top filter bar ── */}
      <TopFilterBar filters={filters} onChange={setFilters} onSearch={()=>search(1)} loading={loading}/>

      {/* ── Results toolbar ── */}
      {leads.length>0&&(
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:8,background:'var(--surface)',border:'1px solid var(--border)',borderRadius:10,padding:'9px 13px',marginBottom:12}}>
          <div style={{display:'flex',alignItems:'center',gap:8,flex:1,minWidth:0,flexWrap:'wrap'}}>
            <span style={{fontSize:13,color:'var(--text3)',whiteSpace:'nowrap'}}>
              <strong style={{color:'var(--text)'}}>{total.toLocaleString()}</strong> leads found
              {filters.location&&<span style={{color:'var(--text3)'}}> in <strong style={{color:'var(--text)'}}>{filters.location}</strong></span>}
            </span>
            <div style={{position:'relative',flex:1,minWidth:100,maxWidth:200}}>
              <span style={{position:'absolute',left:9,top:'50%',transform:'translateY(-50%)',color:'var(--text3)',pointerEvents:'none'}}><Search size={12}/></span>
              <input style={{...S.inputPlain,paddingLeft:28,height:30,fontSize:12}} placeholder="Filter results…" value={query} onChange={e=>setQuery(e.target.value)}/>
            </div>
            <select style={{...S.select,width:135,height:30,fontSize:12}} value={sortBy} onChange={e=>setSortBy(e.target.value)}>
              {SORT_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div style={{display:'flex',gap:6}}>
            <button style={{...S.btnGhost,height:30,fontSize:12}} onClick={()=>selected.length===sorted.length?setSelected([]):setSelected(sorted.map(l=>l.id||l.place_id))}>
              <CheckSquare size={12}/>{selected.length===sorted.length?'Deselect':'Select All'}
            </button>
            {/* <button style={{...S.btnSuccess,height:30,fontSize:12}} onClick={exportLeads}>
              <Download size={12}/>{selected.length>0?`(${selected.length})`:'CSV'}
            </button> */}
          </div>
        </div>
      )}

      {/* Loading */}
      {loading&&(
        <div style={S.emptyState}>
          <div style={{width:38,height:38,border:'3px solid var(--border)',borderTopColor:'var(--accent)',borderRadius:'50%',animation:'spin .7s linear infinite'}}/>
          <div style={{fontWeight:600,fontSize:15}}>{loadMsg||'Searching…'}</div>
          <div style={{fontSize:13,color:'var(--text3)'}}>Finding the best leads for you</div>
        </div>
      )}

      {/* Empty */}
      {!loading&&leads.length===0&&(
        <div style={S.emptyState}>
          <div style={{fontSize:44}}>📡</div>
          <div style={{fontWeight:700,fontSize:18}}>Ready to find leads</div>
          <div style={{fontSize:13.5,color:'var(--text3)',maxWidth:340,lineHeight:1.6}}>Enter a location above, optionally pick a business category, then click Search Leads.</div>
        </div>
      )}

      {/* Grid */}
      {!loading&&sorted.length>0&&(
        <div className="leads-grid">
          {sorted.map(lead=>(
            <LeadCard key={lead.id||lead.place_id} lead={lead}
              selected={selected.includes(lead.id||lead.place_id)}
              onSelect={toggleSel} onSave={l=>setSave(l)} onDetail={setDetail}/>
          ))}
        </div>
      )}

      {/* Pagination */}
      {!loading&&totalPages>1&&(
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:6,marginTop:16}}>
          <button style={S.pageBtn} onClick={()=>search(page-1)} disabled={page===1}><ChevronLeft size={15}/></button>
          {Array.from({length:Math.min(totalPages,7)},(_,i)=>i+1).map(p=>(
            <button key={p} style={page===p?S.pageBtnAct:S.pageBtn} onClick={()=>search(p)}>{p}</button>
          ))}
          <button style={S.pageBtn} onClick={()=>search(page+1)} disabled={page===totalPages}><ChevronRight size={15}/></button>
        </div>
      )}

      {/* Detail modal */}
      {detailLead&&(
        <div style={S.overlay} onClick={e=>e.target===e.currentTarget&&setDetail(null)}>
          <div style={{...S.modal,maxWidth:440}}>
            <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',padding:'18px 20px',borderBottom:'1px solid var(--border)'}}>
              <div>
                <div style={{fontWeight:700,fontSize:16}}>{detailLead.name}</div>
                {Number(detailLead.rating)>0&&<div style={{display:'flex',alignItems:'center',gap:5,marginTop:4,fontSize:13,color:'var(--gold)'}}><Star size={13} fill="var(--gold)" stroke="none"/><strong>{Number(detailLead.rating).toFixed(1)}</strong><span style={{color:'var(--text3)'}}>({Number(detailLead.review_count||0).toLocaleString()} reviews)</span></div>}
              </div>
              <button style={S.btnIcon} onClick={()=>setDetail(null)}><X size={15}/></button>
            </div>
            <div style={{padding:'16px 20px',display:'flex',flexDirection:'column',gap:11}}>
              {[['📍 Address',detailLead.address||detailLead.vicinity],['📞 Phone',detailLead.phone],['📧 Email',detailLead.email],['🌐 Website',detailLead.website],['⚡ Status',detailLead.business_status||detailLead.status],['🎯 Score',detailLead.lead_score]].filter(([,v])=>v).map(([l,v])=>(
                <div key={l} style={{display:'flex',gap:10,alignItems:'flex-start'}}>
                  <span style={{flexShrink:0,width:100,color:'var(--text3)',fontSize:12.5}}>{l}</span>
                  <span style={{fontSize:13,wordBreak:'break-all'}}>{v}</span>
                </div>
              ))}
              <a href={`https://maps.google.com/?q=${encodeURIComponent((detailLead.name||'')+' '+(detailLead.address||''))}`} target="_blank" rel="noopener noreferrer"
                style={{display:'flex',alignItems:'center',justifyContent:'center',gap:6,height:38,borderRadius:8,background:'var(--accent)',color:'#fff',textDecoration:'none',fontWeight:600,fontSize:13,marginTop:4}}>
                <ExternalLink size={14}/> View on Map
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Save modal */}
      {saveModal&&(
        <div style={S.overlay} onClick={e=>e.target===e.currentTarget&&setSave(null)}>
          <div style={{...S.modal,maxWidth:380}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 18px',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontWeight:700,fontSize:15}}>Save Lead</div>
              <button style={S.btnIcon} onClick={()=>setSave(null)}><X size={15}/></button>
            </div>
            <div style={{padding:'14px 18px',display:'flex',flexDirection:'column',gap:12}}>
              <div style={{fontWeight:600,fontSize:13.5,padding:'8px 12px',background:'var(--bg3)',borderRadius:7}}>{saveModal.name}</div>
              <div style={{display:'flex',flexDirection:'column',gap:4}}><label style={{fontSize:12,color:'var(--text3)'}}>List Name</label><input style={S.inputPlain} value={saveForm.listName} onChange={e=>setSaveForm(f=>({...f,listName:e.target.value}))} placeholder="Default"/></div>
              <div style={{display:'flex',flexDirection:'column',gap:4}}><label style={{fontSize:12,color:'var(--text3)'}}>Priority</label><select style={S.select} value={saveForm.priority} onChange={e=>setSaveForm(f=>({...f,priority:e.target.value}))}>{['low','medium','high','urgent'].map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}</select></div>
              <div style={{display:'flex',flexDirection:'column',gap:4}}><label style={{fontSize:12,color:'var(--text3)'}}>Notes</label><textarea style={S.textarea} value={saveForm.notes} onChange={e=>setSaveForm(f=>({...f,notes:e.target.value}))} placeholder="Add notes…"/></div>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:8,padding:'12px 18px',borderTop:'1px solid var(--border)'}}>
              <button style={S.btnGhost} onClick={()=>setSave(null)}>Cancel</button>
              <button style={{...S.btnGhost,background:'var(--accent)',color:'#fff',border:'none',fontWeight:600}} onClick={confirmSave}><Bookmark size={13}/> Save Lead</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}